export default __webpack_public_path__ + "locales/pl/JavascriptSdk.json?hash=196b5697d9223044f84762b20f1c9192";